module.exports = __webpack_public_path__ + "static/img/3s-info-b5.89d489f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-b5.jpg
// module id = 7xkP
// module chunks = 0